import React from 'react';
import { Tooltip } from '../../ui/Tooltip';

interface LlmInstructionsTooltipProps {
  instructions: string;
}

const LlmInstructionsTooltip: React.FC<LlmInstructionsTooltipProps> = ({ instructions }) => {
  if (!instructions) return null;
  return (
    <Tooltip
      content={instructions}
      heading="Instructions LLM"
      maxWidth="max-w-2xl"
      className="text-blue-600"
      ariaLabel="Instructions LLM"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </Tooltip>
  );
};

export default LlmInstructionsTooltip;
